var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("p", { staticClass: "fs-3 m-0 mt-4 info-notifs-settings" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Nous pouvons toujours vous envoyer des notifications importantes concernant votre compte et son contenu en dehors de vos paramètres de notification préférés. Ces préférences ne s'appliqueront qu'à vous."
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-6" }, [
        _c("h3", { staticClass: "m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Ne pas déranger")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fs-3 mt-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Vous pouvez désactiver l’ensemble des notifications."
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "b-1 rounded" }, [
          _c(
            "div",
            { staticClass: "p-3 flex-level" },
            [
              _c("span", { staticClass: "fs-3 bold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Activer ne pas déranger")))
              ]),
              _vm._v(" "),
              _c("el-switch", {
                staticClass: "flex-item-right",
                attrs: { "active-color": "#13ce66" },
                on: { change: _vm.updateNotificationsSettings },
                model: {
                  value: _vm.notDisturbing,
                  callback: function($$v) {
                    _vm.notDisturbing = $$v
                  },
                  expression: "notDisturbing"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mt-6" }, [
        _c("h3", { staticClass: "m-0" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Activer les notifications pour :")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "b-1 rounded mt-3" }, [
          _c(
            "div",
            { staticClass: "px-3 pt-3 pb-2 flex-level" },
            [
              _c("span", { staticClass: "fs-3 bold" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Mentions")))
              ]),
              _vm._v(" "),
              _c("el-switch", {
                staticClass: "flex-item-right",
                attrs: { "active-color": "#13ce66" },
                on: { change: _vm.updateStaffMentionned },
                model: {
                  value: _vm.mentionned,
                  callback: function($$v) {
                    _vm.mentionned = $$v
                  },
                  expression: "mentionned"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "m-0 px-3 pb-3 fs-3" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$l10n.__(
                    "Recevez une notification lorsque vous êtes mentionné dans un commentaire, un objet, etc."
                  )
                ) +
                "\n            "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }